import { Component, forwardRef, Injector, OnInit } from '@angular/core';
import { DynamicComponentBase, IDynamicComponentConfig, RenderComponentBase } from '../../../dynamic-component';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-r-select',
  templateUrl: './r-select.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RSelectComponent),
      multi: true
    }
  ]
})
export class RSelectComponent extends RenderComponentBase {
  static KEY = 'r-d-select';

  constructor(injector: Injector) {
    super(injector);
  }

  configChange(config: IDynamicComponentConfig) {
    if (typeof config.showSearch !== 'boolean') {
      config.showSearch = true;
    }
    if (typeof config.allowClear !== 'boolean') {
      config.allowClear = true;
    }
    if (!Array.isArray(config.dataSource)) {
      config.dataSource = [
        {
          value: '1',
          label: '选项1'
        },
        {
          value: '2',
          label: '选项2'
        },
        {
          value: '3',
          label: '选项3'
        }
      ];
    }
  }
}
